export default {
  sm: `
  This is NAVER DATA CENTER GAK logo.
  In official representations,
  "DATA CENTER GAK" should be located
  in the center of the logo. If shown with
  the region name, it should be
  center-aligned with the region name.
  `,
  md: `
  This is NAVER DATA CENTER GAK logo.
  In official representations,
  "DATA CENTER GAK" should be located in
  the center of the logo. If shown with the
  region name, it should be center-aligned
  with the region name.
  `,
  lg: `
  This is NAVER DATA CENTER GAK logo.
  In official representations, "DATA CENTER GAK"
  should be located in the center of the logo.
  If shown with the region name, it should be
  center-aligned with the region name.
  `,
  xxl: `
  This is NAVER DATA CENTER GAK logo.
  In official representations, "DATA CENTER GAK"
  should be located in the center of the logo.
  If shown with the region name, it should be center-aligned
  with the region name.
  `,
};
